import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const FrameWrap = styled.div`
  width: 100%;
  min-height: 70vh;
  height: calc(100vh - 16rem);
  border-radius: 10px;
  overflow: hidden;
  border: 1px solid ${({ theme }) => theme.colors?.gray03};
  background-color: ${({ theme }) => theme.colors?.backgroundColor};
`;

export const Frame = styled.iframe`
  width: 100%;
  height: 100%;
  min-height: 70vh;
  border: none;
`;
